var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"partner-grant"}},[(!_vm.loading)?_c('ReferringPlatformGrantModal',{attrs:{"referring-platform-slug":_vm.platform.slug,"auth-callback-url":_vm.platform.authCallbackUrl,"email":_vm.platform.email}}):_c('page-loader',{attrs:{"loading":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }